import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchOperators } from '../../services/operators'
import { COLUMN_NAMES } from '../../util/constants'

export const getOperatorsThunk = createAsyncThunk(
    'operator/getOperators',
    async (_, thunkAPI) => {
        const { data, error } = await fetchOperators()
        if (error) return thunkAPI.rejectWithValue({ error: error.message })
        return data || []
    }
)

const initialState = {
    operators: [],
    status: 'idle',
    lastFetched: null,
}

export const operatorSlice = createSlice({
    name: 'operator',
    initialState,
    reducers: {
        setOperators: (state, action) => {
            state.operators = action.payload
        },
        resetOperatorStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOperatorsThunk.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getOperatorsThunk.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.operators = action.payload
                state.lastFetched = Date.now()
            })
            .addCase(getOperatorsThunk.rejected, (state) => {
                state.status = 'failed'
            })
    },
})

export const { setOperators, resetOperatorStatus } = operatorSlice.actions

export const operatorsSelector = (state) => state.operator.operators || []
export const operatorOptionsSelector = (state) => (state.operator.operators || [])
    .filter(op => !op.provider_type || op.provider_type.includes('MAYORISTA'))
    .map(op => ({ value: op.id, label: op.name }))

export const operatorToAssign = (state) => (state.operator.operators || [])
    .filter(op => !op.provider_type || op.provider_type.includes('TRASLADO'))
    .map(op => ({ 
        id: op.id, 
        tableId: op.id, 
        name: op.name, 
        country: op.ruc ? `RUC ${op.ruc}` : 'Operador de Traslado',
        column: COLUMN_NAMES.VALUES_TO_ASSIGN 
    }))

export default operatorSlice.reducer
